import { render } from "./SpinningSquares.vue?vue&type=template&id=3e689869&lang=pug"
import script from "./SpinningSquares.vue?vue&type=script&lang=js"
export * from "./SpinningSquares.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__